import { analytics } from '@/services'
import { Module } from '@/types'
import { navigateToHurdle, openURL } from '@/utils'
import { navigate } from 'gatsby'
import { useCallback, useMemo } from 'react'
import { tryOpenLesson } from '../learn'
import { navigation } from '@/app'

export type ModuleStrategy = {
  matches: (item: Module, isInitial: boolean) => boolean
  execute: (item: Module) => void
}

export function useOpenModule() {
  const openModule = useCallback((module: Module) => {
    analytics.track('collection_view', { collection_name: module.title })
    if (module?.chapters?.length === 1) {
      const chapter = module?.chapters?.[0]
      analytics.track('lesson_view', { lesson_name: chapter?.title })
      tryOpenLesson(chapter?.id)
      return
    } else if (module?.pages?.length > 0) {
      analytics.track('lesson_view', { lesson_name: module?.title })
      tryOpenLesson(module?.id)
      return
    }

    navigate(`/learn/chapter/${module?.id}`)
  }, [])

  const strategies: ModuleStrategy[] = useMemo(() => [
    {
      matches: item => item.type === 'lesson_group',
      execute: item => navigation.navigate('Learn.Content', { id: item.id }),
      name: 'lesson_group',
    },
    {
      matches: item => item.title === 'Hurdle',
      execute: navigateToHurdle,
    },
    {
      matches: item => !!(item.beta_game && item.url),
      execute: item => openURL(item.url),
    },
    {
      matches: item => item.is_free,
      execute: openModule,
    },
    {
      matches: (_, isInitial) => isInitial,
      execute: openModule,
    },
    {
      matches: item => item.is_placeholder,
      execute: () => { },
    },
    {
      matches: () => true,
      execute: openModule,
    },
  ], [])

  const resolveModuleAction = useCallback((item: Module, isInitial: boolean) => {
    const strategy = strategies.find(s => s.matches(item, isInitial))
    if (!strategy) {
      console.warn('No strategy matched for module', item)
      return null
    }

    return strategy
  }, [strategies])

  return { resolveModuleAction, openModule }
}
